module.exports = __webpack_public_path__ + "img/link-broken-02.efef1288.svg";